import { render } from "./ConfigPanel.vue?vue&type=template&id=ee2742fa&scoped=true"
import script from "./ConfigPanel.vue?vue&type=script&lang=js"
export * from "./ConfigPanel.vue?vue&type=script&lang=js"

import "./ConfigPanel.vue?vue&type=style&index=0&id=ee2742fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee2742fa"]])

export default __exports__